import Swal from "sweetalert2";
import renumberStatements from "../../pages/survey/questions/renumber-statements";
import createStatementElement from "../../pages/survey/questions/create-statement-element";
import isStatementsUnderLimit from "../../pages/survey/questions/is-statements-under-limit";
import {checkBrandIsGenderSensitive} from "./statements/check-brand-is-gender-sensitive";
import {showLockIconIfStatementsAreRotatable} from "./statements/show-lock-icon";
import {showGenderColsIfBrandIsGenderSensitive} from "./statements/show-gender-col";
import {swalFire} from "../../plugins/sweet-alert/sweet-alert-default";
import {readWorksheetsFromXlsx, importStatementsFromSheet} from "./import-statements";
import {clearPlaceholderIfBrandIsNotGenderSensitive} from "./statements/clear-placeholder";

export function attachStatements(context) {
    const $context = $(context);
    const $surveyStatements = $context.find('.surveyStatements');

    if (!$context.length) {
        return;
    }

    const statementListPart = $context.find('.statements-list-part').get(0);

    $surveyStatements.on('change', '.edit-respondent input', function () {
        const isChecked = $(this).is(':checked');

        $(this).closest('.statements-edit')
            .find('.statements-item-edit-respondent')
            .toggleClass('hide', !isChecked);
    });

    $surveyStatements.on('click', '.blockStatementSwitch', function (event) {
        event.preventDefault();

        $(this).find('i').each(function (index, i) {
            $(i).toggleClass('hide');
        });

        const isLocked = $(this).parent().find('.lock-closed').hasClass('hide');
        $(this).toggleClass('btn-light', isLocked);
        $(this).toggleClass('btn-warning', !isLocked);
        $(this).parent().find('input').val(!isLocked);
    });

    $context.on('click', '[data-copy-statement]', function (event) {
        event.preventDefault();

        $context.trigger('add-new-statement', [$(this).data('name')]);
    });

    $context.on('copy-statement', function (event, el) {
        const $context = $(this);
        const $el = $(el);
        const data = $el.find('[data-name]').data('name');
        let $statement = createStatementElement($context.find('[data-statement-template]'), data);

        if (!isStatementsUnderLimit()) {
            Swal.fire({
                title: 'Statement limit',
                text: 'You have already used the maximum number of statements in your survey.',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: '<i class="label-icon bx bx-check"></i> Ok',
                customClass: {
                    confirmButton: 'btn btn-label btn-primary btn-min-width'
                }
            });
            $el.remove();

            return;
        }

        $statement = showGenderColsIfBrandIsGenderSensitive($statement, $context);

        // check if rotate statements switch is on
        $statement = showLockIconIfStatementsAreRotatable($statement, $context);

        $statement.insertAfter($el);
        $el.remove();

        // renumber elements
        renumberStatements($surveyStatements);

        $context.trigger('reload-statements-count');
    });

    $context.on('add-new-statement', function (event, data = null, reloadStatementsCount = true) {
        const $context = $(this);

        // Return false if statements count is over limit
        if (!isStatementsUnderLimit()) {
            return;
        }

        let $statement = createStatementElement($context.find('[data-statement-template]'), data);

        $statement = clearPlaceholderIfBrandIsNotGenderSensitive($statement, $context);

        // check if brand is gender sensitive
        $statement = showGenderColsIfBrandIsGenderSensitive($statement, $context);

        // check if rotate statements switch is on
        $statement = showLockIconIfStatementsAreRotatable($statement, $context);

        $statement.appendTo(statementListPart);

        // renumber elements
        renumberStatements($surveyStatements);

        if (reloadStatementsCount) {
            $context.trigger('reload-statements-count', [$context]);
        }
    });

    $context.on('remove-last-statements', function (event, count, reloadStatementsCount = true) {
        const $context = $(this);
        const $statementItems = $context.find('[data-statements-list] [data-statement-item]');
        $statementItems.slice(-count).remove();

        if (reloadStatementsCount) {
            $context.trigger('reload-statements-count');
        }
    });

    $context.on('remove-first-statements', function (event, countImported, reloadStatementsCount = true) {
        const $context = $(this);
        const $statementItems = $context.find('[data-statements-list] [data-statement-item]');
        const count = $statementItems.length - countImported;
        $statementItems.slice(0, count).remove();

        if (reloadStatementsCount) {
            $context.trigger('reload-statements-count');
            if (count) {
                Swal.fire('The number of statements in the file is different from declared for this part. The declared number of statements has been adapted to the file’s content.');
            }
        }

        renumberStatements($context);
    });

    $context.on('establish-statements', function (event, count) {
        const $context = $(this);
        const $statementItems = $context.find('[data-statements-list] [data-statement-item]');
        const statementsCount = $statementItems.length;

        // Add new statement inputs
        if (statementsCount < count) {
            const addStatementsCount = count - statementsCount;
            for (let i = 1; i <= addStatementsCount; i++) {
                $context.trigger('add-new-statement', [null, false]);
            }
        }

        // Remove more statements input than needed
        if (statementsCount > count) {
            const removeStatementsCount = statementsCount - count;
            $context.trigger('remove-last-statements', [removeStatementsCount, false]);
        }
    });

    $context.on('reload-statements-count', function (event) {
        const $context = $(this);
        const $statementItems = $context.find('[data-statements-list] [data-statement-item]');
        const statementsCount = $statementItems.length;
        $context.find('.statements-nr-input input').val(statementsCount).trigger('change');
    });

    $context.on('remove-statement', function (event, el) {
        const $context = $(this);

        Swal.fire({
            title: 'Remove',
            text: 'Do you really want to delete this statement?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: '<i class="label-icon bx bx-trash"></i> Delete',
            cancelButtonText: '<i class="label-icon bx bx-arrow-back"></i> Cancel',
            customClass: {
                confirmButton: 'btn btn-label btn-danger btn-min-width',
                cancelButton: 'btn btn-label btn-primary btn-min-width'
            }
        }).then((result) => {
            if (result.value !== true) {
                return;
            }

            $(el).closest('.statements-mylist-item').slideUp().remove();

            // renumber elements
            renumberStatements($surveyStatements);

            $context.trigger('reload-statements-count');
        });
    });

    $context.on('click', 'button[data-add-new-statement]', function (event) {
        event.preventDefault();

        // Return false if statements count is over limit
        if (!isStatementsUnderLimit()) {
            Swal.fire({
                title: 'Statement limit',
                text: 'You have already used the maximum number of statements in your survey.',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: '<i class="label-icon bx bx-check"></i> Ok',
                customClass: {
                    confirmButton: 'btn btn-label btn-primary btn-min-width'
                }
            });

            return;
        }

        $context.trigger('add-new-statement');
    });

    $surveyStatements.on('click', 'button.delete-statement', function (event) {
        event.preventDefault();

        $context.trigger('remove-statement', [$(this)]);
    });

    $context.on('change', '[data-import-statements-from-file]', function (event) {
        event.preventDefault();

        readWorksheetsFromXlsx(this.files[0]).then(function (worksheets) {
            swalFire({
                title: 'Select worksheet',
                input: 'select',
                inputOptions: worksheets.map(sheet => sheet.name),
                customClass: {
                    input: 'form-control',
                    confirmButton: 'btn btn-label btn-min-width',
                    cancelButton: 'btn btn-label btn-min-width'
                },
                cancelButtonColor: '#74788d',
                showCancelButton: true
            }).then(function (result) {
                if (result.isConfirmed) {
                    importStatementsFromSheet(worksheets, result.value, $context);
                }
            });
        });
    });

    $context.on('toggle-statements-brand-gender-sensitive', function () {
        const $context = $(this);
        const switchValue = checkBrandIsGenderSensitive($context);

        $context.find('[data-statement-brand-gender-col]').each(function () {
            $(this).toggleClass('hide', !switchValue);
            const placeholderText = switchValue ? 'Male stimulus' : '';
            $context.find('input[data-name-male-male]').attr('placeholder', placeholderText);
            $context.find('input[data-name-male-female]').attr('placeholder', placeholderText);
        });
    });

    $context.on('set-statements-lock-icons-visibility', function (event, rotateStatementsSwitch) {
        const $rotateStatementsSwitch = $(rotateStatementsSwitch);
        const rotateStatementsSwitchVal = $rotateStatementsSwitch.prop('checked');

        let $blockButton = $(this).find('.blockStatementSwitch');

        if (true === rotateStatementsSwitchVal) {
            $(this).find('.blockStatementSwitch').removeClass('hide');
        } else {
            $(this).find('.blockStatementSwitch').addClass('hide'); 
            $blockButton.parent().find('input').val(0);
            $blockButton.removeClass('btn-warning');
            $blockButton.addClass('btn-light');
            $blockButton.find('.lock-closed').addClass('hide');
            $blockButton.find('.lock-open').removeClass('hide');
        }
    });

    $context.find('[data-rotate-statements-switch]').each(function () {
        $context.trigger('set-statements-lock-icons-visibility', $(this));
    });
}
